import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.liquidation',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.liquidation/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.liquidation/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.liquidation/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.liquidation/${id}`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.liquidation/${id}/apply`,
    method: 'put',
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.liquidation/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.liquidation/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number) => {
  return axiosService({
    url: `/api.liquidation/${id}/approve`,
    method: 'put',
    data: {},
  })
}

export const complete = (id: number, data: any) => {
  return axiosService({
    url: `/api.liquidation/${id}/complete`,
    method: 'put',
    data,
  })
}

export const exportDocx = (id: number, data: any) => {
  return axiosService({
    url: `/api.liquidation/${id}/export`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.liquidation/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.liquidation',
    method: 'post',
    data,
  })
}
